// The catalogue barrel.
//
// EN is the SOURCE catalogue (the doctor-app rule, docs/I18N.md there): every
// key is declared in en.js, and fa.js, fr.js and de.js translate it. A key in
// only one translation is a defect, and tests/i18n.test.js asserts parity with
// en in both directions for every catalogue here. A locale enters SUPPORTED
// (config.js) only together with its complete catalogue.
//
// All of them live in ./translations/ so a screen's copy can be reviewed
// without scrolling past the mechanism.
//
// One flat map per locale, with fully qualified dotted keys, rather than the
// doctor app's namespace-per-file + lazy loader. This app has six screens and
// one bundle; the loader's job — not shipping fifteen JSON files to render one
// screen — does not exist here yet. The KEY SHAPE is identical, so promoting to
// the namespaced loader later is a mechanical move that touches no screen.

import { en } from './translations/en.js';
import { fa } from './translations/fa.js';
import { fr } from './translations/fr.js';
import { de } from './translations/de.js';

export { en, fa, fr, de };

export const catalogs = { en, fa, fr, de };
